import { CloseIcon } from "@/Icons/Close";
import HamburgerIcon from "@/Icons/Hamburger";
import UserButton from "@/UI/Header/components/UserButton";
import { useConfig } from "@/api/hooks/useConfig";
import Search from "@/components/Search";

import React from "react";

interface SearchbarProps {
  toggleMenu: () => void;
  sidebarOpen: boolean;
}

export const HeaderMWM: React.FC<SearchbarProps> = ({
  toggleMenu,
  sidebarOpen,
}) => {
  const { config } = useConfig();

  return (
    <div className="fixed top-0 right-0 z-20 flex h-16 w-full items-center justify-between bg-white px-4 sm:px-8 md:w-[calc(100%-theme(space.64))]">
      <div className="flex items-center gap-4">
        <button onClick={toggleMenu} className="md:hidden">
          {sidebarOpen ? <CloseIcon /> : <HamburgerIcon />}
        </button>
        {config.useExternalCRM && <Search />}
      </div>
      <UserButton />
    </div>
  );
};

export default HeaderMWM;
